import React from 'react';

import type { GenericErrorBoundaryProps } from './GenericErrorBoundary.tsx';
import { GenericErrorBoundary } from './GenericErrorBoundary.tsx';

export type TransparentErrorBoundaryProps = Pick<
	GenericErrorBoundaryProps,
	'attribution' | 'children' | 'onError'
>;

const NullErrorComponent = () => null;

export const TransparentErrorBoundary = ({
	attribution,
	children,
	onError,
}: TransparentErrorBoundaryProps): React.JSX.Element => (
	<GenericErrorBoundary
		attribution={attribution}
		renderOnError={NullErrorComponent}
		onError={onError}
	>
		{children}
	</GenericErrorBoundary>
);
